export enum UserTypes {
  FETCH_USERS = 'FETCH_USERS',
}
